/* eslint-disable @typescript-eslint/no-namespace */
export namespace Enums {
  export enum CyborgIndexEnum {
    CYBORG_COLLECTIONS = 'cyborg_collections',
    CYBORG_USE_CASES = 'cyborg_usecases',
    CYBORG_CONTENT = 'cyborg_content',
    CYBORG_THREAT_PROFILES = 'cyborg_threat_profiles',
    CYBORG_CUSTOM_HUNT_PACKAGES = 'cyborg_custom_hunt_packages',
    SIGHTINGS = 'sightings',
  }

  export enum CyborgTagTypeEnum {
    TOOLS = 'tools',
    PLATFORM_TYPES = 'platform_types',
    DATA_SOURCES = 'data_sources',
    GOALS = 'goals',
    DEPENDENCIES = 'dependencies',
    THREAT_NAMES = 'threat_names',
    THREAT_CATEGORIES = 'threat_categories',
    THREAT_TYPES = 'threat_types',
    ATTACK_SURFACES = 'attack_surfaces',
    TARGET_OSES = 'target_oses',
    ACTORS = 'actors',
    TOOLING = 'tooling',
    DIAMOND_MODELS = 'diamond_models',
    KILL_CHAINS = 'kill_chains',
    MITRE_TACTIC_NAMES = 'mitre_tactic_names',
    MITRE_TECHNIQUE_NAMES = 'mitre_technique_names',
    MITRE_TECHNIQUE_IDS = 'mitre_technique_ids',
    SOURCE_COUNTRIES = 'source_countries',
    SOURCE_REGIONS = 'source_regions',
    TARGET_COUNTRIES = 'target_countries',
    TARGET_REGIONS = 'target_regions',
    TARGET_INDUSTRIES = 'target_industries',
    EXPLOIT_OR_VULNS = 'exploit_or_vulns',
    MOTIVATIONS = 'motivations',
    SEVERITIES = 'severities',
    CAMPAIGNS = 'campaigns',
    OPERATIONS = 'operations',
    TARGET_OS_VERSIONS = 'target_os_versions',
  }

  export enum CyborgTermTypeEnum {
    CUSTOM = 'custom',
    TAG = 'tag',
  }

  // The order here matters, it is the order in the sort dropdown.
  export enum CyborgSortEnum {
    RELEVANCE = 'relevance',
    LAST_UPDATED_DESC = 'last_updated_desc',
    LAST_UPDATED_ASC = 'last_updated_asc',
    CREATED_DATE_DESC = 'created_date_desc',
    CREATED_DATE_ASC = 'created_date_asc',
    TYPE_ASC = 'type_asc',
    TYPE_DESC = 'type_desc',
    TITLE_ASC = 'title_asc',
    TITLE_DESC = 'title_desc',
  }

  export enum FilterRangeEnum {
    ALL_TIME = 'all_time',
    LAST_WEEK = 'last_week',
    LAST_MONTH = 'last_month',
    LAST_QUARTER = 'last_quarter',
  }

  export enum FilterTagEnum {
    THREAT_NAME = 'threat_name',
    THREAT_CATEGORIES = 'threat_categories',
    THREAT_TYPE = 'threat_types',
    INDUSTRY = 'industry',
    REGION = 'region',
    COUNTRY = 'country',
    ACTORS = 'actors',
    SEVERITY = 'severity',
    MOTIVATIONS = 'motivations',
  }
  export enum IndustryEnum {
    Banking,
  }
  // TODO: Consolidate this with values from matchboi SupportedTools
  export enum SiemTypeEnum {
    SPLUNK = 'Splunk',
    ELASTIC = 'Elastic',
  }

  export enum SummaryTypeEnum {
    TRENDING = 'trending',
    MITRE = 'mitre',
    USE_CASES_CONTENT = 'use_cases_and_content',
    THREAT_INTELLIGENCE = 'threat_intelligence',
    MY_ENVIRONMENT = 'my_environment',
  }
  export enum UserRoleEnum {
    ADMINISTRATOR = 'administrator',
    LEAD_ANALYST = 'lead_analyst',
    ANALYST = 'analyst',
    ENGINEER = 'engineer',
  }

  export enum FeedbackTypeEnum {
    SUPPORT = 'Support',
    TUNING = 'Tuning',
    SYNTAX = 'Syntax',
    REQUEST = 'Request',
  }

  export enum PriorityEnum {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
  }

  export enum SeverityEnum {
    LOW = 'Low',
    MEDIUM = 'Medium',
    MODERATE = 'Moderate',
    HIGH = 'High',
    CRITICAL = 'Critical',
  }

  export enum OutcomeEnum {
    VISIBILITY_GAP = 'Visibility Gap',
    NO_FINDINGS = 'No Findings',
    DETECTION = 'Detection',
    ESCALATED = 'Escalated',
  }

  export enum StatusEnum {
    TO_DO = 'To Do',
    IN_PROGRESS = 'In Progress',
    DONE = 'Done',
  }

  export enum QueryStatusEnum {
    TO_DO = 'To Do',
    SKIP = 'Skip',
    RUN = 'run',
  }

  export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
  }

  export enum Goals {
    HUNT = 'Hunt',
    BEHAVIOR = 'Behavior',
    TARGETED = 'Targeted',
    VISUAL = 'Visual',
    DETECTION = 'Detection',
  }

  export enum CompanyStatus {
    TRIAL = 'trial',
    ACTIVE = 'active',
    EXPIRED = 'expired',
    POC = 'poc',
  }

  export enum TrackingEventEnum {
    AUTH_LOGIN = 'auth.login',
    AUTH_TIME_IN_APP = 'auth.timeInApp',
    HUNT_METADATA = 'hunt.metadata',
    HUNT_REPORT_EXPORTED = 'hunt.huntReportExported',
    HUNT_DASHBOARD_EXPORTED = 'hunt.huntDashboardExported',
    RESEARCH_HUNT_PACKAGE_ACCESSED = 'research.huntPackageAccessed',
    RESEARCH_HUNT_PACKAGE_CONTENT_ACCESSED = 'research.huntPackageContentAccessed',
    RESEARCH_SEARCH = 'research.searchExecuted',
    RESEARCH_THREAT_PROFILE_ACCESSED = 'research.threatProfileAccessed',
    RESEARCH_VALIDATION_PACKAGE_DOWNLOADED = 'research.validationPackageDownloaded',
    COMMUNITY_REACTIVATION_REACTION = 'community.reactivationReason',
    COMMUNITY_CALENDLY_DIALOG_OPENED = 'community.calendlyDialogOpened',
    COMMUNITY_PREMIUM_DIALOG_OPENED = 'community.premiumDialogOpened',
    COMMUNITY_PREMIUM_DIALOG_ABANDONED = 'community.premiumDialogAbandoned',
    COMMUNITY_TALK_WITH_US_DIALOG_OPENED = 'community.talkWithUsDialogOpened',
    COMMUNITY_TALK_WITH_US_DIALOG_ABANDONED = 'community.talkWithUsDialogAbandoned',
    COMMUNITY_HUNT_MODULE_DIALOG_OPENED = 'community.huntModuleDialogOpened',
    COMMUNITY_HUNT_MODULE_DIALOG_ABANDONED = 'community.huntModuleDialogAbandoned',
    COMMUNITY_CALENDLY_MEETING_SCHEDULED = 'community.calendlyMeetingScheduled',
    COMMUNITY_CALENDLY_MEETING_CANCELED = 'community.calendlyMeetingCanceled',
  }

  export enum ActionEnum {
    MANAGE = 'manage',
    CREATE = 'create',
    READ = 'read',
    UPDATE = 'update',
    DELETE = 'delete',
  }

  export enum SourceEnum {
    INTERNAL = 'Internal',
    CUSTOMER = 'Customer',
    INTEL = 'Intel',
  }

  export enum CollectionTypeEnum {
    EMERGING = 'Emerging',
    ADVISORY = 'Advisory',
    MALWARE_AND_ACTOR_SUMMARY = 'Malware and Actor Summary',
    MITRE_TECHNIQUES_TACTICS = 'MITRE Techniques/Tactics',
  }

  export enum HuntCategoryEnum {
    PROCESS_CREATION = 'process_creation',
    NETWORK_CONNTECTION = 'network_connection',
    REGISTRY_EVENT = 'registry_event',
    FILE_EVENT = 'file_event',
    IMAGE_LOAD = 'image_load',
    AUTHENTICATION_EVENTS = 'authentication_events',
    RDP_EVENT = 'Rdp_event',
    CLOUD = 'cloud',
    DNS = 'dns',
    FIREWALL = 'firewall',
    PROXY = 'proxy',
    APPLICATION = 'application',
    WEBSERVER = 'webserver',
    PIPE_CREATED = 'pipe_created',
    SECURITY = 'security',
    SYSTEM = 'system',
  }
}
